<template>
  <div>
    <wc-data-box
      :title='details.title'
      :titleIcon='details.icon'
      :titleIconColor='details.iconColor'
      :showEdit='!project.archived'
      @edit='editDetails'
    >
      <wc-two-column-table :items='items'></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='details.title'
      :icon='details.icon'
      :iconColor='details.iconColor'
      @cancel='showDialog = false'
      @save='saveEdit'
      :disableButtons='!isFormValid'
      width='400'
    >
      <v-form v-model='isFormValid'>
        <v-row>
          <v-col cols='8' offset='1'>
            <v-text-field
              label="PO Number"
              v-model='projectCopy.project_detail.po_number'
            ></v-text-field>
          </v-col>
          <v-col cols='8' offset='3'>
            <v-text-field
              id='amount'
              label="Amount"
              v-model='projectCopy.project_detail.po_total'
              :rules='[rules.decimalOrEmpty]'
              reverse
              prepend-icon='mdi-currency-usd'
              @focus='selectAmount'
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import formRules from '@/mixins/formRules'
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  name: 'construction-project-details',
  mixins: [formRules],
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    showDialog: false,
    projectCopy: { project_detail: {} }
  }),
  computed: {
    items () {
      let tmp = [
        { text: 'PO Number', value: this.project.project_detail.po_number },
        { text: 'PO Amount', value: this.project.project_detail.po_total ? this.$options.filters.decMoney(this.project.project_detail.po_total) : ""}
      ]
      return tmp
    },
    ...mapState ({
      details: state => state.icons.dataBox.details
    })
  },
  methods: {
    editDetails () {
      this.projectCopy = _.cloneDeep(this.project)
      this.showDialog = true
    },
    cancelEdit () {
      this.showDialog = false
    },
    saveEdit () {
      if (this.projectCopy.project_detail.po_total === "") {
        this.projectCopy.project_detail.po_total = null
      }
      this.$emit('update', this.projectCopy)
      this.cancelEdit()
    },
    selectAmount() {
      setTimeout(() => {
        document.getElementById('amount').select()
      }, 50)
    },
  }
}
</script>
